module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/c9aca0a61586e7831b135bd8518c81ac.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_assign-start.svg
// module id = GOEc
// module chunks = 0